import { Reveal } from "./Reveal";

const REASONS = [
  ["Diesel & Gasoline Experience", "Both worlds, one shop — from daily drivers to heavy-duty diesels."],
  ["Professional Diagnostic Equipment", "Dealer-level scan tools and live-data analysis on every job."],
  ["Honest Repair Recommendations", "We tell you what your vehicle actually needs. Nothing more."],
  ["Clear Communication", "Straight answers, plain language, no surprises on the invoice."],
  ["Quality Work", "Repairs done to spec, the first time. Good work speaks for itself."],
  ["Work Pickup & Fleet Experience", "We understand downtime costs money — we keep your work pickups moving."],
  ["Locally Operated in Oklahoma City", "Your neighbors. Our reputation is built one repair at a time."],
];

export const WhyUs = () => (
  <section id="about" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-zinc-950 border-y border-zinc-800" data-testid="why-us-section">
    <Reveal>
      <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">04 — Why Choose Us</p>
      <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02] max-w-3xl" data-testid="why-us-heading">
        Where Good Work <span className="text-[#FF3B30]">Speaks for Itself</span>
      </h2>
    </Reveal>

    <div className="mt-16">
      {REASONS.map(([title, desc], i) => (
        <Reveal key={title} delay={i * 0.04}>
          <div className="relative flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-10 py-7 border-b border-zinc-800 group" data-testid={`why-item-${i + 1}`}>
            <span className="font-oswald font-bold text-5xl sm:text-7xl leading-none text-zinc-800 group-hover:text-[#FF3B30]/40 transition-colors duration-300 select-none sm:w-32 shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <h3 className="font-oswald uppercase tracking-tight text-2xl sm:text-3xl group-hover:text-[#FF3B30] transition-colors duration-300">{title}</h3>
              <p className="mt-1 text-zinc-400 text-sm sm:text-base max-w-2xl">{desc}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
